export default class ReasonsRegistrationDomain {
  static normalize(raw) {
    if (!raw || typeof raw !== 'object') {
      return {
        vd0motivo: '',
        vd0nome: ''
      }
    }

    return {
      vd0motivo: this.normalizeMotivo(raw.vd0motivo),
      vd0nome: this.normalizeNome(raw.vd0nome)
    }
  }

  static normalizeMotivo(value) {
    if (value === null || value === undefined) return ''
    return String(value).trim()
  }

  static normalizeNome(value) {
    if (value === null || value === undefined) return ''
    return String(value).trim()
  }
}
